import type { RenterPaymentMethodInterface } from '@renter-hub/models/Types';

export type PendingBankAccountInfo = {
  mask: string;
  bankName: string;
};

export const findDuplicatePaymentMethod = (
  pendingAccount: PendingBankAccountInfo,
  existingPaymentMethods: Array<RenterPaymentMethodInterface>,
): RenterPaymentMethodInterface | undefined => {
  for (const paymentMethod of existingPaymentMethods) {
    if (paymentMethod.accountLast4 === pendingAccount.mask && paymentMethod.bankName === pendingAccount.bankName) {
      return paymentMethod;
    }
  }

  return undefined;
};
